var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivemic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 222,
    viewBox: "0 0 222 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4232_4559",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 222,
    height: 222
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222 0H0V222H222V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4232_4559)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.999 39.3652C150.535 39.3652 182.635 71.4649 182.635 111C182.635 150.536 150.535 182.636 110.999 182.636C71.464 182.636 39.3643 150.536 39.3643 111C39.3643 71.4649 71.464 39.3652 110.999 39.3652Z",
    fill: "#4B81EF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.353871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 16.791C162.994 16.791 205.209 59.0064 205.209 111.001C205.209 162.995 162.994 205.21 111 205.21C59.0054 205.21 16.79 162.995 16.79 111.001C16.79 59.0064 59.0054 16.791 111 16.791Z",
    fill: "#E3ECFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.999 49.5059C144.938 49.5059 172.494 77.0615 172.494 111C172.494 144.939 144.938 172.495 110.999 172.495C77.0605 172.495 49.5049 144.939 49.5049 111C49.5049 77.0615 77.0605 49.5059 110.999 49.5059Z",
    fill: "#4C82EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.999 49.5059C144.938 49.5059 172.494 77.0615 172.494 111C172.494 144.939 144.938 172.495 110.999 172.495C77.0605 172.495 49.5049 144.939 49.5049 111C49.5049 77.0615 77.0605 49.5059 110.999 49.5059Z",
    fill: "#4C82EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.917 109.594C125.917 118.037 118.768 123.948 110.999 123.948C103.231 123.948 96.0818 118.037 96.0818 109.594H91.2969C91.2969 119.191 98.9527 127.129 108.185 128.508V137.74H113.814V128.508C123.046 127.157 130.702 119.22 130.702 109.594H125.917ZM110.999 118.037C115.672 118.037 119.415 114.266 119.415 109.594L119.443 92.7057C119.443 88.0333 115.672 84.2617 110.999 84.2617C106.327 84.2617 102.555 88.0333 102.555 92.7057V109.594C102.555 114.266 106.327 118.037 110.999 118.037Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivemic);
export default __webpack_public_path__ + "static/media/active mic.2ef5c13664992d71045627c65d298ebf.svg";
export { ForwardRef as ReactComponent };